import { defineComponent as y, ref as v, computed as a, resolveComponent as c, openBlock as p, createElementBlock as u, normalizeClass as t, createElementVNode as n, createVNode as g, createTextVNode as f, toDisplayString as h, withModifiers as b, createCommentVNode as O } from "vue";
import { O as _ } from "./OrIconButton-BlHCLpeW.mjs";
import { O as S } from "./OrIcon-k8cyvh-D.mjs";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const T = [
  // Layout
  "layout-row",
  // Interactivity
  "interactivity-click",
  // Shape
  "rounded-full",
  // Box
  "h-[44px] md:h-[32px]",
  // Spacing
  "px-md md:px-sm+",
  "py-0",
  "gap-md+ md:gap-md",
  // Typography
  "typography-button",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark",
  // Theme (hover)
  "hover:theme-foreground-primary-hover",
  "dark:hover:theme-foreground-primary-hover-dark",
  "hover:theme-background-primary-translucent-1",
  "dark:hover:theme-background-primary-translucent-1-dark",
  // Theme (selected)
  "selected:theme-foreground-primary",
  "dark:selected:theme-foreground-primary-dark",
  "selected:theme-background-primary-translucent-1",
  "dark:selected:theme-background-primary-translucent-1-dark",
  // Theme (activated)
  "activated:theme-background-primary-translucent-1",
  "dark:activated:theme-background-primary-translucent-1-dark",
  // Theme (.icon)
  "[&_.icon]:theme-foreground-primary",
  "dark:[&_.icon]:theme-foreground-primary-dark",
  // Theme (.icon / hover)
  "[&_.icon]:hover:theme-foreground-primary-hover",
  "dark:[&_.icon]:hover:theme-foreground-primary-hover-dark"
], w = [
  // Layout
  "layout-row",
  // Spacing
  "gap-xs"
], B = [
  // Layout
  "layout-row",
  // Shape
  "rounded-full",
  // Box
  "h-[36px] md:h-[24px]",
  // Spacing
  "px-sm+ md:px-sm",
  "py-0",
  "gap-sm+ md:gap-sm",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark",
  "theme-background-default",
  "dark:theme-background-default-dark"
], C = y({
  name: "OrFilterTrigger",
  components: {
    OrIcon: S,
    OrIconButton: _
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [Number, String],
      default: void 0
    },
    label: {
      type: String,
      default: "Filters"
    }
  },
  emits: [
    "reset",
    "click"
  ],
  expose: [
    "root"
  ],
  setup(e, r) {
    const d = v(), s = a(() => [
      "or-filter-trigger-v3",
      ...T
    ]), i = a(() => [
      ...w
    ]), l = a(() => [
      ...B
    ]);
    function o() {
      r.emit("reset");
    }
    return {
      root: d,
      rootStyles: s,
      labelStyles: i,
      tagStyles: l,
      reset: o
    };
  }
}), F = ["selected", "activated"], I = {
  key: 0,
  class: /* @__PURE__ */ t(["layout-inline-row", "-m-[12px] md:-m-[8px]"])
}, $ = {
  class: /* @__PURE__ */ t(["layout-inline-row", "-m-[4px]"])
};
function N(e, r, d, s, i, l) {
  const o = c("OrIcon"), k = c("OrIconButton");
  return p(), u("div", {
    ref: "root",
    class: t(e.rootStyles),
    selected: e.isOpen,
    activated: !!e.value,
    onClick: r[1] || (r[1] = (m) => e.$emit("click", m))
  }, [
    n("div", {
      class: t(e.labelStyles)
    }, [
      g(o, {
        class: t("icon"),
        icon: "filter_list"
      }),
      f(" " + h(e.label), 1)
    ], 2),
    e.value ? (p(), u("div", I, [
      n("div", {
        class: t(e.tagStyles)
      }, [
        f(h(e.value) + " ", 1),
        n("div", $, [
          g(k, {
            icon: "close",
            onClick: r[0] || (r[0] = b((m) => e.reset(), ["stop"]))
          })
        ])
      ], 2)
    ])) : O("", !0)
  ], 10, F);
}
const L = /* @__PURE__ */ x(C, [["render", N]]);
export {
  L as O
};
//# sourceMappingURL=OrFilterTrigger-CiScTjiQ.mjs.map
